import type { TAddressesResponse } from "../models/addresses";
import type { TAddressSearchEntry } from "../types";

const mapAddressSearchResponse = (response: TAddressesResponse): TAddressSearchEntry[] =>
  (response.items || []).map((item) => ({
    id: item.id,
    title: item.title,
  }));

export default mapAddressSearchResponse;
